import { useCallback } from 'react'
import { useParams, generatePath } from 'react-router-dom'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { useApiQuery } from 'admin/lib/Api'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import styled from 'styled-components'
import { GetPageNames } from 'admin/lib/GetPageNames'
import { EditNotification } from './NotificationEdit'
import * as ROUTES from 'admin/routes'

export function Notification() {
  const { accountId, projectId, notificationId } = useParams()

  const notification = useApiQuery(
    useCallback(
      api => {
        if (notificationId == 'register') {
          return [{}, null, null]
        }
        return api.getNotification(accountId, projectId, notificationId)
      },
      [accountId, notificationId, projectId]
    )
  )

  const pageNames = GetPageNames(accountId, projectId)

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={generatePath(ROUTES.ACCOUNTS.LIST)}>
                  Accounts
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  {pageNames.data && pageNames.data.accountName}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  href={generatePath(ROUTES.NOTIFICATIONS.LIST, {
                    accountId: accountId,
                    projectId: projectId
                  })}
                >
                  {pageNames.data && pageNames.data.projectName}
                </BreadcrumbArrayItem>
              )
            }
          ]}
        />
      }
    >
      {!notification.loaded && <ScreenSpin />}

      {notification.loaded && (
        <EditSection>
          <EditNotification
            notification={notification.data}
            isNew={notificationId == 'register'}
            accountId={accountId}
            projectId={projectId}
            notificationId={notificationId}
          />
        </EditSection>
      )}
    </Layout>
  )
}

const EditSection = styled.div`
  margin: auto;
  width: 30rem;
`
